import { mergeObjectsButOverrideArrays } from '../utils/merge';

export default function mergeConfig<T = unknown>(
  defaultConfig: T,
  overrideConfig: Partial<T>
) {
  return mergeObjectsButOverrideArrays(defaultConfig, overrideConfig);
}
